import { Stack, styled } from '@ethings/ui-toolkit';
import { FC, type JSX } from 'react';
import { useSmallScreen } from '../../hooks';

const NestedItemStack = styled(Stack)(({ theme }) => ({
  '& > div': {
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
  },
}));

export const FormatStack: FC<{ left: JSX.Element; right: JSX.Element }> = ({ left, right }) => {
  const smallScreen = useSmallScreen();

  if (smallScreen) {
    return (
      <NestedItemStack m={1} width="100%">
        {left}
        {right}
      </NestedItemStack>
    );
  }

  return (
    <>
      <NestedItemStack m={1} width="100%">{left}</NestedItemStack>
      <NestedItemStack m={1} width="100%">{right}</NestedItemStack>
    </>
  );
};

